import { Modal } from 'antd';
import React from 'react';
import { Link } from 'react-router-dom';

const modalStyles = {
    container: {
        textAlign: 'center',
        padding: '8px 0',
    },
    icon: {
        fontSize: '52px',
        marginBottom: '12px',
        display: 'block',
    },
    title: {
        fontSize: '24px',
        fontWeight: 700,
        color: '#1a1a1a',
        marginBottom: '8px',
        letterSpacing: '-0.5px',
    },
    subtitle: {
        fontSize: '14px',
        color: '#666',
        marginBottom: '24px',
        lineHeight: '1.5',
    },
    disabledBox: {
        background: 'linear-gradient(135deg, #fff2f0 0%, #ffccc7 100%)',
        border: '1px solid #ffa39e',
        borderRadius: '12px',
        padding: '24px 20px',
        marginBottom: '20px',
    },
    disabledTitle: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '8px',
        fontSize: '16px',
        fontWeight: 600,
        color: '#cf1322',
        marginBottom: '12px',
    },
    disabledText: {
        fontSize: '14px',
        color: '#a8071a',
        lineHeight: '1.6',
    },
    helpLink: {
        marginTop: '20px',
        paddingTop: '16px',
        borderTop: '1px solid #f0f0f0',
        fontSize: '13px',
        color: '#8c8c8c',
    },
};

const BattleLinkModal = ({ visible, handleBattleModalVisibility }) => {
    const handleCancel = () => {
        handleBattleModalVisibility(false);
    };

    return (
        <Modal
            open={visible}
            footer={null}
            onCancel={handleCancel}
            centered
            width={480}
        >
            <div style={modalStyles.container}>
                <span style={modalStyles.icon}>⚔️</span>
                <h2 style={modalStyles.title}>Multiplayer</h2>
                <p style={modalStyles.subtitle}>
                    Soutěž s přáteli v reálném čase.<br />
                    Kdo bude rychlejší a přesnější?
                </p>

                <div style={modalStyles.disabledBox}>
                    <div style={modalStyles.disabledTitle}>
                        <span>🚫</span>
                        Multiplayer je dočasně nedostupný
                    </div>
                    <div style={modalStyles.disabledText}>
                        Omlouváme se, ale z důvodu omezených API kreditů je multiplayer dočasně vypnutý.
                        Spotřebovává příliš mnoho zdrojů a ohrožoval by fungování singleplayer her.
                        <br /><br />
                        Zkus to prosím později, nebo si zatím zahraj sám.
                    </div>
                </div>

                <div style={modalStyles.helpLink}>
                    Herní princip je popsán v{' '}
                    <Link to="/napoveda" style={{ color: '#c80707', fontWeight: 500 }}>
                        nápovědě
                    </Link>
                </div>
            </div>
        </Modal>
    );
};

export default BattleLinkModal;
